<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NjN869/tc-custom/9781627886437.jpg?1705766095532" alt="This image is the cover for the book Beer Wench's Guide to Beer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beer Wench's Guide to Beer
      </h1>
      <p class="bookDescription body article font2">
        <p>Pull up a stool and learn about beer with the Wench!Craft beer is officially everywhere: there are now more breweries in the United States since any time before prohibition. At the local grocery store, the beer aisle is as big as the cereal aisle. At the bar, it's increasingly hard to choose a beer--the IPA is stronger than the ESB, right?In this book, Ashley V. Routson (aka The Beer Wench) provides the first all-in-one guide that demystifies beer and makes learning fun. She'll quickly bring you up to speed on beer styles, the brewing process, how to taste beer like a pro, and how to pair beer with food. Unconventional tastings, delicious recipes from killer craft breweries, eye-catching photos--and, of course, plenty of beer--means there's never a dull moment.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashley Routson
      </h2>
      
      <p class="authorDescription body article">Known as The Beer Wench, Ashley V. Routson is a craft beer evangelist and social media maven on a mission to advance the craft beer industry through education, inspiration, and advocacy. By day, Ashley works in the brewing industry and has spent years training others in beer tasting and beer quality control, as well as promoting craft beer brands. In her off hours, Ashley is a beer writer who has written for or been featured on NPR, DRAFT magazine, Beer Advocate, and Time.com, among others. She's a regular contributor to both CraftBeer.com (run by the Brewer's Association) and the Whole Foods Market blog, and the founder of IPA Day. Ashley has been a featured speaker at the Craft Brewers Conference, The Great American Beer Festival, and the Beer Bloggers Conference. Find her on Twitter: @TheBeerWench</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Voyageur Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d2446bc0